import cz from '../csCZ/dashlets';

const en: typeof cz = {
	search: {
		title: 'Search',
		text:
			'Allows you to search in addition operations and indexes according to selected criteria.',
	},
	help: {
		title: 'Help',
		text:
			'Frequently asked questions about Digital Archive search and features.',
	},
	contact: {
		title: 'Contact',
		text:
			'Contact information for the Brno City Archive and a form for any questions from researchers.',
	},
};

export default en;
